import React, { createContext, useContext, useRef, useState } from "react";
import ReactDOM from "react-dom";

const PopupContext = createContext();
export const usePopup = () => useContext(PopupContext);

export const PopupProvider = ({ children }) => {
    const [popups, setPopups] = useState([]);
    const popupIdRef = useRef(null);

    const showPopup = (content, options = {}) => {
        const id = Date.now();
        setPopups((prev) => [...prev, { id, content, options }]);
        popupIdRef.current = id;
        return id;
    };

    const hidePopup = (id) => {
        setPopups((prev) => prev.filter((p) => p.id !== id));
    };

    const updatePopup = (id, content) => {
        setPopups((prev) => prev.map((p) => p.id === id ? { ...p, content } : p));
    };

    // 최근에 실행된 팝업을 닫음
    const hideLastPopup = () => {
        hidePopup(popupIdRef.current);
    }

    // 조건없이 모든 팝업을 닫음
    const hideAllPopup = () => {
        setPopups([]);
    }

    return (
        <PopupContext.Provider value={{ showPopup, hidePopup, hideLastPopup, hideAllPopup, updatePopup }}>            
            {children}
            {popups.map(({ id, content, options }) =>
                ReactDOM.createPortal(
                    <div
                        key={id}
                        className="fixed inset-0 flex items-center justify-center z-50 bg-[rgba(0,0,0,0.5)] bg-opacity-10 transition-opacity p-4"
                        onClick={() => options.closeOnOverlayClick && hidePopup(id)}
                    >
                        <div
                            className={options.className + " w-full bg-white rounded-lg p-6 shadow-lg animate-fadeIn"}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {content}
                        </div>
                    </div>,
                    document.body
                )
            )}
        </PopupContext.Provider>
    );
};